import api from './axios';

export const listar = (id_cliente_final) => {
  const params = {};
  if (id_cliente_final) params.id_cliente_final = id_cliente_final;
  return api.get('/areas-cliente/', { params });
};
export const criar     = (data)     => api.post('/areas-cliente/', data);
export const atualizar = (id, data) => api.patch(`/areas-cliente/${id}`, data);
